export const uncheckChips = (selectedValues: string[] | number[], value: string) => {
    return selectedValues.filter((e) => String(e) !== value) as string[] | number[];
};
